import React from 'react';

import { Paper, Divider } from '@occc/ui-design-system';
import { PerMemberActivationLimit, GlobalActivationLimit } from '@occc/feat-limits';

import { RequiresActivationConstraintWithLimitsFormValues } from './types';
import { RequiresActivationConstraint } from './requires-activation-constraint';

interface RequiresActivationConstraintWithLimitsProps {
  values: RequiresActivationConstraintWithLimitsFormValues;
}

export const RequiresActivationConstraintWithLimits: React.FC<
  RequiresActivationConstraintWithLimitsProps
> = ({ values }) => {
  return (
    <RequiresActivationConstraint values={values}>
      <Paper variant='outlined'>
        <PerMemberActivationLimit open={Boolean(values?.membership?.isEnabled)} />
        <Divider />
        <GlobalActivationLimit open={Boolean(values?.global?.isEnabled)} />
      </Paper>
    </RequiresActivationConstraint>
  );
};
